(function() {
  'use strict';

  const drawer = document.getElementById('filter-drawer');
  const backdrop = document.getElementById('filter-drawer-backdrop');
  const closeBtn = document.getElementById('filter-drawer-close');
  const applyBtn = document.getElementById('filter-drawer-apply');
  const clearBtn = document.getElementById('filter-drawer-clear');
  const form = document.getElementById('FilterDrawerForm');

  function openDrawer() {
    if (!drawer) {
      console.warn('[FilterDrawer] Elemento #filter-drawer não encontrado');
      return;
    }
    const drawerContent = document.getElementById('filter-drawer-content');
    drawer.style.display = 'block';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (drawerContent) {
          drawerContent.classList.remove('-translate-x-full');
        }
      });
    });
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    const drawerContent = document.getElementById('filter-drawer-content');
    if (drawerContent) {
      drawerContent.classList.add('-translate-x-full');
    }
    setTimeout(function() {
      drawer.style.display = 'none';
    }, 300);
    document.body.style.overflow = '';
  }

  // Normaliza um valor de preço para envio na URL.
  // Se o usuário digitar no formato brasileiro (ex: 1.234,56), converte para 1234.56
  // Se digitar no formato number (ex: 1234.56), mantém.
  // O resultado é sempre em REAIS (não multiplica por 100).
  function normalizePrice(value) {
    var str = String(value).trim();
    if (!str) return '';
    // Se contém vírgula, assume formato brasileiro (ponto=milhar, vírgula=decimal)
    if (str.indexOf(',') !== -1) {
      str = str.replace(/\./g, '').replace(',', '.');
    }
    var num = parseFloat(str);
    if (isNaN(num) || num < 0) return '';
    return num;
  }

  // Aplicar filtros
  if (applyBtn && form) {
    applyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var formData = new FormData(form);
      var params = new URLSearchParams();

      var entries = formData.entries ? Array.from(formData.entries()) : [];
      for (var i = 0; i < entries.length; i++) {
        var key = entries[i][0];
        var value = entries[i][1];
        if (value && String(value).trim() !== '') {
          if (key.indexOf('filter.v.price') !== -1) {
            var priceValue = normalizePrice(value);
            if (priceValue !== '') {
              params.append(key, priceValue);
            }
          } else {
            params.append(key, value);
          }
        }
      }

      var url = form.action + (params.toString() ? '?' + params.toString() : '');
      window.location.href = url;
    });
  }

  // Limpar filtros
  if (clearBtn && form) {
    clearBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var baseUrl = form.action || window.location.pathname;
      var currentParams = new URLSearchParams(window.location.search);
      var newParams = new URLSearchParams();

      ['q', 'type', 'options[prefix]', 'sort_by'].forEach(function(key) {
        var currentValue = currentParams.get(key);
        var formField = form.querySelector('[name="' + key.replace(/"/g, '\\"') + '"]');
        var value = currentValue || (formField ? formField.value : '');
        if (value) {
          newParams.set(key, value);
        }
      });

      var url = baseUrl + (newParams.toString() ? '?' + newParams.toString() : '');
      window.location.href = url;
    });
  }

  // Fechar com backdrop
  if (backdrop) {
    backdrop.addEventListener('click', closeDrawer);
  }

  // Fechar com botão
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  // Fechar com ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.style.display !== 'none') {
      closeDrawer();
    }
  });

  // Delegação de evento para botões de abrir drawer
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-filter-drawer-toggle]');
    if (toggle) {
      e.preventDefault();
      openDrawer();
    }
  });

  // Price Range Slider
  function initPriceRangeSliders() {
    var wrappers = document.querySelectorAll('[data-price-range-wrapper]');
    wrappers.forEach(function(wrapper) {
      var minRange = wrapper.querySelector('[data-range="min"]');
      var maxRange = wrapper.querySelector('[data-range="max"]');
      var fill = wrapper.querySelector('[data-price-range-fill]');
      var container = wrapper.closest('[data-price-filter]');
      var minInput = container ? container.querySelector('[data-price-input="min"]') : null;
      var maxInput = container ? container.querySelector('[data-price-input="max"]') : null;
      var labelMin = container ? container.querySelector('[data-price-range-label-min]') : null;
      var labelMax = container ? container.querySelector('[data-price-range-label-max]') : null;

      if (!minRange || !maxRange || !fill) return;

      var minVal = parseInt(minRange.min, 10) || 0;
      var maxVal = parseInt(minRange.max, 10) || 100;

      function formatMoney(value) {
        var num = parseInt(value, 10) || 0;
        return num.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }

      function getCurrencySymbol() {
        if (labelMin) {
          var text = labelMin.textContent || '';
          var match = text.match(/^[^\d,\s]+/);
          if (match) return match[0].trim() + ' ';
        }
        return 'R$ ';
      }

      function updateFill() {
        var min = parseInt(minRange.value, 10);
        var max = parseInt(maxRange.value, 10);
        var rangeSize = maxVal - minVal;
        var percentMin = rangeSize > 0 ? ((min - minVal) / rangeSize) * 100 : 0;
        var percentMax = rangeSize > 0 ? ((max - minVal) / rangeSize) * 100 : 100;
        fill.style.left = percentMin + '%';
        fill.style.width = (percentMax - percentMin) + '%';
      }

      function updateInputs() {
        var min = parseInt(minRange.value, 10);
        var max = parseInt(maxRange.value, 10);
        if (minInput) minInput.value = min;
        if (maxInput) maxInput.value = max;
        var symbol = getCurrencySymbol();
        if (labelMin) labelMin.textContent = symbol + formatMoney(min);
        if (labelMax) labelMax.textContent = symbol + formatMoney(max);
      }

      function parseInputValue(el) {
        if (!el || !el.value) return 0;
        var num = normalizePrice(el.value);
        return typeof num === 'number' ? num : 0;
      }

      function updateRangesFromInputs() {
        var min = parseInputValue(minInput);
        var max = parseInputValue(maxInput);
        if (min < minVal) min = minVal;
        if (max > maxVal) max = maxVal;
        if (min > max) min = max;
        minRange.value = min;
        maxRange.value = max;
        updateFill();
        updateInputs();
      }

      function onMinRangeChange() {
        var min = parseInt(minRange.value, 10);
        var max = parseInt(maxRange.value, 10);
        if (min > max - 1) {
          min = max - 1;
          if (min < minVal) min = minVal;
          minRange.value = min;
        }
        updateFill();
        updateInputs();
      }

      function onMaxRangeChange() {
        var min = parseInt(minRange.value, 10);
        var max = parseInt(maxRange.value, 10);
        if (max < min + 1) {
          max = min + 1;
          if (max > maxVal) max = maxVal;
          maxRange.value = max;
        }
        updateFill();
        updateInputs();
      }

      function bringToFront(el) {
        if (!el) return;
        el.style.zIndex = '3';
      }

      function resetZIndex() {
        if (minRange) minRange.style.zIndex = '';
        if (maxRange) maxRange.style.zIndex = '1';
      }

      minRange.addEventListener('input', onMinRangeChange);
      minRange.addEventListener('mousedown', function() { bringToFront(minRange); });
      minRange.addEventListener('touchstart', function() { bringToFront(minRange); }, { passive: true });
      minRange.addEventListener('mouseup', resetZIndex);
      minRange.addEventListener('touchend', resetZIndex);

      maxRange.addEventListener('input', onMaxRangeChange);
      maxRange.addEventListener('mousedown', function() { bringToFront(maxRange); });
      maxRange.addEventListener('touchstart', function() { bringToFront(maxRange); }, { passive: true });
      maxRange.addEventListener('mouseup', resetZIndex);
      maxRange.addEventListener('touchend', resetZIndex);

      if (minInput) {
        minInput.addEventListener('input', function() {
          updateRangesFromInputs();
        });
        minInput.addEventListener('change', function() {
          updateRangesFromInputs();
        });
      }

      if (maxInput) {
        maxInput.addEventListener('input', function() {
          updateRangesFromInputs();
        });
        maxInput.addEventListener('change', function() {
          updateRangesFromInputs();
        });
      }

      // Inicializar
      updateFill();
      updateInputs();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceRangeSliders);
  } else {
    initPriceRangeSliders();
  }

  // Expor globalmente
  window.openFilterDrawer = openDrawer;
  window.closeFilterDrawer = closeDrawer;
})();
